import './gb-category-dropdown.tag.html';
import './gb-category-section.tag.html';
riot.tag2('gb-category-menu', '<div class="gb-menu {_style}"> <div class="gb-menu__item" each="{opts.sections}"> <gb-category-dropdown class="gb-category-dropdown"></gb-category-dropdown> </div> </div>', 'gb-category-menu .gb-stylish.gb-menu,[riot-tag="gb-category-menu"] .gb-stylish.gb-menu,[data-is="gb-category-menu"] .gb-stylish.gb-menu{ display: flex; flex-direction: row; justify-content: center; }', '', function(opts) {
});



/** WEBPACK FOOTER **
 ** ./src/tags/category-menu/gb-category-menu.tag.html
 **/